import items from "../../data/press/items.json";
import Container from "../../components/landing/Container";
import HeadComponent from "../../components/landing/Head";
import Card from "../../components/Card";
import Header from "../../components/aboutus/Header";
import SEO from "../../data/seo.json";

import ContactUsForm from "../../components/landing/ContactUsForm";

const Press = () => (
  <div>
    <HeadComponent SEO={SEO} />
    <Container>
      <Header title="The Data Mynt Press" />
      <div className={"p-12 space-y-8"}>
        <ul className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}>
          {items.map(item => (
            <Card
              key={item["name"]}
              {...{
                ...item,
                link: `/press/${item["name"]}`,
                linkSource: "Read more"
              }}
            />
          ))}
        </ul>
      </div>
      <div className="bg-wrapper py-12">
        <ContactUsForm />
      </div>
    </Container>
  </div>
);

export default Press;
